import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatSelect } from '@angular/material/select';
import { filter } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-corporate-add',
  templateUrl: './corporate-add.component.html',
  styleUrls: ['./corporate-add.component.css'],
})
export class CorporateAddComponent implements OnInit {
  menuOrder: number | null;
  uploadedFile: File | null = null;
  selectedFileName: string | null = null;
  bsLastValue;
  bsFromValue;
  bsToValue;
  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
  applyLastMin;
  fromDateMin;
  fromDateMax;
  lastDateMin;
  intiativeForm: FormGroup;
  datas;

  fileSizeError = false;
  private saveApi = environment.url + environment.initiativeSave;
  private getApi = environment.url + environment.initiativeGet;
  displayedColumns: string[] = [
    'index',
    'test',
    'menuOrder',
    'showInMenu',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  /**
   * CorporateAddComponent constructor.
   * @param data Dialog data.
   * @param _locale MAT_DATE_LOCALE.
   * @param route ActivatedRoute.
   * @param fb FormBuilder.
   * @param makeapi ApiService.
   * @param getdata ValueService.
   * @param notify NotifyService.
   * @param sanitizer DomSanitizer.
   * @param dialogRef MatDialogRef<CorporateAddComponent>.
   * @param dialog MatDialog.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<CorporateAddComponent>,
    public dialog: MatDialog
  ) {
    // Initialize the MatTableDataSource.
    this.dataSource = new MatTableDataSource();
    // Get the dialog data.
    this.datas = data;
    // If the dialog data title is 'Update', get the corporate details from the database.
    if (data.title == 'Update') {
      this.savelbl = 'Update';
      this.getCorporateDetails(data._id);
    } else {
      // Set the apply last date to today if the dialog data title is not 'Update'.
      this.applyLastMin = new Date();
      // Set the from date to today if the dialog data title is not 'Update'.
      this.fromDateMin = new Date();
    }
    // Create the form group with the required fields.
    this.intiativeForm = this.fb.group({
      id: [0],
      title: ['', [Validators.required]],
      aboutusTitle: ['', [Validators.required]],
      redirectLink: ['', [Validators.required]],
      aboutusContent: ['', [Validators.required]],
      matrixName1: ['', [Validators.required]],
      matrixName2: ['', [Validators.required]],
      matrixName3: ['', [Validators.required]],
      matrixValue1: ['', [Validators.required]],
      matrixValue2: ['', [Validators.required]],
      matrixValue3: ['', [Validators.required]],
      sloganContent: ['', [Validators.required]],
      pointersTitle: ['', [Validators.required]],
      pointers: ['', [Validators.required]],
      initiativesBenefits: this.fb.array([this.createItem()]),
      bannerImageName: [''],
      aboutusImageName: [''],
      logoName: [''],
      logo: [''],
      aboutusImage: [''],
      bannerImage: [''],
      menuOrder: [
        '',
        [
          Validators.required,
          this.validateMenuOrder,
          Validators.pattern('^((\\+91-?)|1)?[1-9]{1,}$'),
        ],
      ],
      showInMenu: ['', [Validators.required]],
    });
  }
  get showInMenuValue() {
    return this.intiativeForm.get('showInMenu')?.value;
  }
  getFromDate(event) {
    this.lastDateMin = event;
  }
  getToDate(event) {
    this.fromDateMax = event;
  }
  get add() {
    return this.intiativeForm.controls;
  }
  get array() {
    return this.f.initiativesBenefits as FormArray;
  }
  get f() {
    return this.intiativeForm.controls;
  }
  get showInMenuControl() {
    return this.intiativeForm.get('showInMenu');
  }

  /**
   * Handle the selection of a country from the dropdown.
   * @param value the selected country code
   */
  onSelectCountry(value: string) {
    // Set the value of the showInMenu form control to the selected country code.
    this.showInMenuControl.setValue(value);
  }
  roleValue;
  savelbl = 'Save';
  sample;
  sample2;
  userId;
  aboutUs: any = [];
  /**
   * OnInit lifecycle hook. Called when the component is initialized.
   * 1. Clear the initiativesBenefits form array.
   * 2. If the page is not an update page, add a row to the initiativesBenefits form array.
   * 3. Set the isVisibleSource observable in the ValueService to true.
   * 4. Watch for changes in the route query parameters. If the _id parameter is present, call the viewEvent() method.
   * 5. Get the user role from session storage and store it in the component property roleValue.
   * 6. Get the user id from session storage and add it to the intiativeForm.
   * 7. Set up the form controls.
   */
  ngOnInit(): void {
    // Clear the initiativesBenefits form array.
    while (this.array.length !== 0) {
      this.array.removeAt(0);
    }

    // If the page is not an update page, add a row to the initiativesBenefits form array.
    if (this.datas.title != 'Update') {
      this.benifitaddrow();
    }

    // Set the isVisibleSource observable in the ValueService to true.
    this.getdata.isVisibleSource.next(true);

    // Watch for changes in the route query parameters. If the _id parameter is present, call the viewEvent() method.
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        this.viewEvent(atob(params._id));
      });

    // Get the user role from session storage and store it in the component property roleValue.
    this.roleValue = sessionStorage.getItem('role');

    // Get the user id from session storage and add it to the intiativeForm.
    let id: number = +sessionStorage.getItem('userId');
    let getform = this.intiativeForm.value;
    getform.incubatorId = id;
    this.intiativeForm.patchValue(getform);

    // Set up the form controls.
    this.createItem();
  }

  /**
   * Deletes a row from the initiative benefits form array.
   * If the row being deleted does not have an id (i.e., it is a new row), it is simply removed from the array.
   * If the row being deleted has an id, it is sent to the server to be deleted.
   * @param id The id of the row to delete.
   * @param ind The index of the row in the array.
   */
  deleteValue(id: number, ind: number) {
    if (id == 0) {
      this.array.removeAt(ind);
      this.notify.notifysuccess('Delete row successfully');
    }
  }
  /**
   * Adds a new row to the initiative benefits form array.
   * The new row is a FormGroup with controls for benefit title, benefit content, and id.
   * Both benefit title and content are required fields.
   */
  benifitaddrow() {
    // Push the new form group to the form array
    this.array.push(this.createItem());
    // Notify the user that a new row has been added
    // this.notify.notifysuccess('New row added successfully');
  }
  /**
   * Validator function for menu order.
   * @param control AbstractControl to be validated.
   * @returns { [key: string]: boolean } | null
   *  - If the value is 0 or '0', returns { invalidMenuOrder: true }
   *    indicating that the menu order is invalid.
   *  - Otherwise, returns null, indicating that the menu order is valid.
   */
  validateMenuOrder(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const value = control.value;
    if (value === 0 || value === '0') {
      return { invalidMenuOrder: true };
    }
    return null;
  }

  url;
  /**
   * Creates and returns a new FormGroup for an initiative benefit item.
   * This form group includes controls for benefit title, benefit content, and id.
   * Both benefit title and content are required fields.
   *
   * @returns {FormGroup} A new FormGroup instance for an initiative benefit item.
   */
  createItem() {
    return this.fb.group({
      benefitTitle: ['', [Validators.required]], // Title of the benefit, required field
      benefitContent: ['', [Validators.required]], // Content of the benefit, required field
      id: '0', // Default ID value
    });
  }
  index: number = 0;
  /**
   * This function is used to add a new row to the initiatives benefits form array.
   * It first checks if the form is invalid and if so, it marks all the form controls as touched
   * and displays an error message. If the form is valid, it adds a new row to the form array
   * and displays a success message.
   * @param i - The index of the row to add.
   */
  addRow(i) {
    this.index = i;
    if (this.array.invalid) {
      // Mark all the form controls as touched
      this.array.markAllAsTouched();
      // Display an error message
      this.notify.notifyError('Form is invalid');
    } else {
      // Add a new row to the form array
      this.array.push(this.createItem());
      // Display a success message
      this.notify.notifysuccess('New row added successfully');
    }
  }

  namePush = [];
  /**
   * This function is used to get the corporate details from the API.
   * The response is then used to populate the form with the corporate details.
   * The images are also loaded from the API and the image URLs are stored in the component.
   * @param id - The id of the corporate to get the details for.
   */
  getCorporateDetails(id: number) {
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'get')
      .subscribe((data: any) => {
        // If the banner image exists, store the image and the image URL
        if (data.bannerImageURL != '' && data.bannerImageURL != undefined) {
          this.ImageValue = data.bannerImage;
          this.image_url1 = data.bannerImageURL;
          this.img_name1 = data.bannerImageURL;
        }
        // If the logo image exists, store the image and the image URL
        if (data.logoNameURL != '' && data.logoNameURL != undefined) {
          this.ImageValue2 = data.logo;
          this.image_url2 = data.logoNameURL;
          this.img_name2 = data.logoNameURL;
        }
        // If the about us image exists, store the image and the image URL
        if (data.aboutusImageURL != '' && data.aboutusImageURL != undefined) {
          this.ImageValue3 = data.aboutusImage;
          this.image_url3 = data.aboutusImageURL;
          this.img_name3 = data.aboutusImageURL;
        }
        // Patch the form with the corporate details
        this.intiativeForm.patchValue(data);
        // Patch the form array with the initiatives benefits
        for (let j = 0; j < data.initiativesBenefits.length; j++) {
          this.array.push(
            this.fb.group({
              id: [],
              benefitTitle: [],
              benefitContent: [],
            })
          );
        }
        this.array.patchValue(data.initiativesBenefits);
      });
  }
  ImageValue: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/upload.png';
  image_url1: any = 'assets/images/upload.png';
  img: any;
  logoCheck = false;
  maxSizeMB = 10;
  imageFile: any = [];
  img_name1 = '';
  filesize = false;
  /**
   * This function is used to select an image and set the selected image value,
   * image name, and image URL.
   * The image size is checked and the image is only accepted if it is less than
   * the maximum allowed size.
   * The image type is checked and the image is only accepted if it is a valid
   * image format (jpeg, jpg, png).
   * @param event - The event triggered when an image is selected.
   */
  onSelectImage(event) {
    this.selecetdImage = event.target.files[0];
    if (event.target.files && this.selecetdImage) {
      // Check the image size
      const fileSizeMB = this.selecetdImage.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        // If the image size is larger than the maximum allowed size, set the
        // filesize to true and return
        this.filesize = true;
        return;
      }
      // Read the selected image
      let reader = new FileReader();
      let data = this.selecetdImage;
      this.imagetype = data.type;
      let imagedatatype = this.imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        // Check if the image type is valid
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png'
      ) {
        // If the image type is valid, set the image value, image name, and image
        // URL
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          this.url1 = reader.result;
          let spl = this.url1.split(',');
          this.ImageValue = spl[1];
          this.imageFile = spl[1];
          this.img_name1 = this.fileValue.name;
          this.logoCheck = false;
          this.image_url1 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
        };
      } else {
        // If the image type is invalid, set the img to 'show' and notify the user
        this.img = 'show';
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }
  ImageValue2: any = [];
  imgFormat2: any;
  selecetdImage2: File;
  imagetype2: any;
  fileValue2: File;
  url2: any = 'assets/images/upload.png';
  img_name2 = '';
  image_url2: any = 'assets/images/upload.png';
  img2: any;
  logoCheck2 = false;
  filesize2 = false;
  imageFile2: any = [];
  /**
   * Handles image upload events for logo image, processes the selected image, and updates the logo image information.
   * Only accepts jpeg, jpg, and png file types.
   *
   * @param event - The image input change event.
   */
  onSelectImage2(event) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileSizeMB = selectedFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.filesize2 = true;
        return;
      }
      const reader = new FileReader();
      const data = selectedFile;
      const fileType = data.type;
      const fileExtension = fileType.split('/')[1];
      if (
        fileExtension === 'jpeg' ||
        fileExtension === 'jpg' ||
        fileExtension === 'png'
      ) {
        this.img = '';
        const fileValue = selectedFile;
        reader.readAsDataURL(fileValue);
        reader.onload = () => {
          this.url2 = reader.result;
          const fileUrlSplit = this.url2.split(',');
          this.ImageValue2 = fileUrlSplit[1];
          this.imageFile2 = fileUrlSplit[1];
          this.img_name2 = fileValue.name;
          this.logoCheck2 = false;
          this.image_url2 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url2
          );
          this.uploadedFile = selectedFile || null;
          // Set selected file name
          if (this.uploadedFile) {
            this.selectedFileName = this.uploadedFile.name;
          }
        };
      } else {
        this.img = 'show';
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }
  ImageValue3: any = [];
  imgFormat3: any;
  selecetdImage3: File;
  imagetype3: any;
  fileValue3: File;
  url3: any = 'assets/images/upload.png';
  img_name3 = '';
  image_url3: any = 'assets/images/upload.png';
  img3: any;
  logoCheck3 = false;
  filesize3 = false;
  imageFile3: any = [];
  /**
   * Handles image upload events, processes the selected image, and updates the image information.
   * Only accepts jpeg, jpg, and png file types.
   *
   * @param event - The image input change event.
   */
  onSelectImage3(event) {
    this.selecetdImage3 = event.target.files[0];
    if (event.target.files && this.selecetdImage3) {
      const fileSizeMB = this.selecetdImage3.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.filesize3 = true;
        return;
      }
      let reader = new FileReader();
      let data = this.selecetdImage3;
      this.imagetype = data.type;
      let imagedatatype = this.imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        // Validate the image type
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png'
      ) {
        // Process the image
        this.img = '';
        this.fileValue = this.selecetdImage3;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          this.url1 = reader.result;
          let spl = this.url1.split(',');
          // Save the image data and name
          this.ImageValue3 = spl[1];
          this.imageFile2 = spl[1];
          this.img_name3 = this.fileValue.name;
          // Set the image URL and logo check
          this.logoCheck3 = false;
          this.image_url3 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
          // Set the selected file name
          this.uploadedFile = event.target.files[0] || null;
          if (this.uploadedFile) {
            this.selectedFileName = this.uploadedFile.name;
          }
        };
      } else {
        // Notify the user if the image type is invalid
        this.img = 'show';
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }

  selecetdFile: any = [];
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  docName;
  /**
   * Handles file upload events, processes the selected file, and updates the file information.
   * Only accepts jpeg, jpg, and png file types.
   *
   * @param event - The file input change event.
   */
  fileUpload(event) {
    // Select the first file from the file input
    this.selecetdFile = event.target.files[0];

    if (event.target.files && this.selecetdFile) {
      const reader = new FileReader();
      const imagetype = this.selecetdFile.type;
      const imagedatatype = imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Check if the file type is one of the allowed types
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png'
      ) {
        reader.readAsDataURL(this.selecetdFile);

        reader.onload = () => {
          // Process the uploaded file and extract the base64 data
          this.url = reader.result;
          const spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.docName = this.selecetdFile.name;
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }
  /**
   * Handles the delete button click event.
   * Resets the file value, clears the document name, and removes the event registration QR code.
   */
  deleteImage() {
    // Reset the file value
    this.FileValue = '';
    // Clear the document name
    this.FileName = '';
    this.docName = '';
    // Get the current form values
    let getform = this.intiativeForm.value;
    // Clear the event registration QR code
    getform.eventRegQR = '';
    getform.eventRegQRFileName = '';
    // Update the form with the cleared values
    this.intiativeForm.patchValue(getform);
  }
  /**
   * Handles the save button click event.
   * Validates the form, attaches image values if present, and submits the data to the API.
   * Shows notifications based on the result.
   */
  saveInitiatives() {
    let getform = this.intiativeForm.value;
    if (getform) {
      // Attach image values if present
      if (this.ImageValue != '') {
        getform.bannerImage = this.ImageValue;
        getform.bannerImageName = this.img_name1;
      }
      if (this.ImageValue2 != '') {
        getform.logo = this.ImageValue2;
        getform.logoName = this.img_name2;
      }
      if (this.ImageValue3 != '') {
        getform.aboutusImage = this.ImageValue3;
        getform.aboutusImageName = this.img_name3;
      }

      // Check if all the image fields are empty
      if (
        getform.aboutusImage == '' &&
        getform.bannerImage == '' &&
        getform.logoName == ''
      ) {
        if (this.imageFile == '') {
          this.logoCheck = true;
        }
        if (this.imageFile2 == '') {
          this.logoCheck2 = true;
        }
        if (this.imageFile3 == '') {
          this.logoCheck3 = true;
        }
      }

      // Validate the form
      if (this.intiativeForm.invalid) {
        this.intiativeForm.markAllAsTouched();
        this.notify.notifyError('Please fill all the mandatory fields !!');
      } else {
        // Check if all the image fields are empty
        if (
          getform.aboutusImage == '' &&
          getform.bannerImage == '' &&
          getform.logoName == ''
        ) {
          if (this.imageFile == '') {
            this.logoCheck = true;
          }
          if (this.imageFile2 == '') {
            this.logoCheck2 = true;
          }
          if (this.imageFile3 == '') {
            this.logoCheck3 = true;
          }
        } else {
          // Submit the form data to the API
          this.getdata.amizhthLoader('show');
          this.makeapi
            .method(this.saveApi, getform, 'post')
            .subscribe((data) => {
              this.getdata.amizhthLoader('hide');
              if (data.responseStatus == 'Success') {
                this.notify.notifysuccess(data.responseMessage);
                this.cancelInitiatives();
              } else {
                this.notify.notifyError(data.responseMessage);
              }
            });
        }
      }
    }
  }
  /**
   * Resets the initiative form and closes the dialog.
   */
  cancelInitiatives(): void {
    // Reset the form
    this.intiativeForm.reset();
    // Close the dialog
    this.dialogRef.close();
  }

  protected _onDestroy = new Subject();

  public Editor = ClassicEditor;
  public onReady(editor: ClassicEditor) {}
  public onChange({ editor }: ChangeEvent) {}
  eventView: any = [];
  /**
   * Fetches the event details from the API using the provided ID.
   * The data is stored in the component's `eventView` property.
   * @param id The ID of the event to fetch.
   */
  viewEvent(id: string): void {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'getunauth')
      .subscribe((data: any) => {
        this.getdata.amizhthLoader('hide');
        this.eventView = data;
      });
  }
  /**
   * Closes the dialog and returns to the previous page.
   */
  backBtn(): void {
    // Close the dialog
    this.dialogRef.close();
  }
  showElement: boolean = false;
  /**
   * Toggles the visibility of an element.
   * This method switches the boolean value of `showElement`
   * to either show or hide the element.
   */
  toggleElement(): void {
    // Flip the boolean value of showElement
    this.showElement = !this.showElement;
  }
}
